import React, { useState } from 'react';
import './vendor/vendor.css';
import Vendors from './vendor/Vendor';
import { Link } from 'react-router-dom';
export const baseurl = 'https://api-2c7zncavpa-uc.a.run.app/';
// export const baseurl = 'http://127.0.0.1:5001/cocopeat-homee/us-central1/api/';
// https://api-2c7zncavpa-uc.a.run.app

export const ApiKey = 'AIzaSyDSfbcYYG0FRS3-LAnR9FPI3h8LnB8e-yQ';
export const mapId = '4ce4561ce37f77cb51c51ca7';

function CoocpeatHome() {
    const [searchTerm, setSearchTerm] = useState('');

    return (
        <div className='backcolour'>
            <div className='vendors-page'>
                <header className="header">
                    <Link to="/">
                        <img
                            src={require("../asset/CocopeatAssests/homee-logo new small 1.png")}
                            alt="App Logo"
                            className="logo-img"
                        />
                    </Link>

                    <div className="search-box">
                        <input
                            type="text"
                            placeholder="Search vendors..."
                            aria-label="Search vendors"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button onClick={() => { }} className="search-btn" aria-label="Search">
                            <img
                                src={require("../asset/CocopeatAssests/Search.png")}
                                alt="Search icon"
                            />
                        </button>
                    </div>
                    <Link to="/Cart">
                        <img
                            src={require("../asset/CocopeatAssests/Group 39.png")}
                            alt="Cart"
                            className="cart-btn-icon"
                        />
                    </Link>
                </header>

                {/* Pass searchTerm as prop */}
                <Vendors searchTerm={searchTerm} />
            </div>
        </div>
    );
}

export default CoocpeatHome;
